/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  ArchiveDocumentTypesListParams,
  PaginatedArchiveDocumentTypeList
} from '../model';

import {
  environment
} from 'environments/environment';



import { filterParams, HttpClientBodyOptions, HttpClientEventOptions, HttpClientObserveOptions, HttpClientResponseOptions } from '../httpClientOptions';

@Injectable({ providedIn: 'root' })
export class ArchiveDocumentTypesService {
  private readonly http = inject(HttpClient);
 list<TData = PaginatedArchiveDocumentTypeList>(params?: ArchiveDocumentTypesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 list<TData = PaginatedArchiveDocumentTypeList>(params?: ArchiveDocumentTypesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 list<TData = PaginatedArchiveDocumentTypeList>(params?: ArchiveDocumentTypesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  list<TData = PaginatedArchiveDocumentTypeList>(
    params?: ArchiveDocumentTypesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-document-types/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-document-types/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/archive-document-types/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
};

